import React from 'react';

const AnimationContext = React.createContext(null);

export { AnimationContext };
